module.exports = __webpack_public_path__ + "img/logo.b1f9c365.png";